export enum FileOrFolder {
    FILE = 'FILE',
    FOLDER = 'FOLDER',
}

export enum FileRegion {
    GENERIC = 'GENERIC',
    ASSESSMENT = 'ASSESSMENT',
    FINDING = 'FINDING',
}

export enum CommentVisibility {
    PUBLIC = 'PUBLIC',
    PRIVATE = 'PRIVATE',
    INTERNAL = 'INTERNAL',
    EXTERNAL = 'EXTERNAL',
}

export enum WorkflowType {
    DISPUTE = 'DISPUTE',
    SOC = 'SOC',
}

export enum WorkflowStatus {
    CREATED = 'CREATED',
    ASSIGNED = 'ASSIGNED',
    REVIEWED = 'REVIEWED',
    APPROVED = 'APPROVED',
    REJECTED = 'REJECTED',
    REDISPUTED = 'REDISPUTED',
    RESOLVED = 'RESOLVED',
}

export enum ScanType {
    PCI = 'PCI',
    EVS = 'EVS',
    IVS = 'IVS',
}

export enum Frequency {
    ONCE = 'ONCE',
    DAILY = 'DAILY',
    WEEKLY = 'WEEKLY',
    MONTHLY = 'MONTHLY',
    QUARTERLY = 'QUARTERLY',
}

export enum SortTypes {
    ASC = 'ASC',
    DESC = 'DESC',
}

export enum Operation {
    ADD = 'add',
    REMOVE = 'remove',
    REPLACE = 'replace',
    COPY = 'copy',
    MOVE = 'move',
    TEST = 'test',
}
